import type { CommitmentVersion } from '@festina/life-general-types/life'
import type { Optional } from '@festina-life/core'
import { createRequiredAndOptionalContext } from '@festina-life/ui/libs'

export type CommitmentSimulationContext<
  T extends CommitmentVersion = CommitmentVersion,
> = {
  currentVersion?: Optional<T>
  previousVersion?: Optional<T>
  isDiffing: boolean
}

const [
  useCommitmentSimulationContext,
  useOptionalCommitmentSimulationContext,
  Provider,
] = createRequiredAndOptionalContext<
  CommitmentSimulationContext<CommitmentVersion>
>('CommitmentSimulationContext')

export {
  Provider,
  useCommitmentSimulationContext,
  useOptionalCommitmentSimulationContext,
}
